<template>
  <div class="container">
    <div>
      <h1>
        Summary: <span class="campaign-title">{{ campaignName }}</span>
      </h1>
    </div>
    <div v-if="status == 'CREATED'">
      <sdx-loading-spinner ref="spinnerPrice" size="large" sr-hint="Loading. Please wait." class="spinner-dashboard"
                           style="display: none"/>
      <div id="price" ref="price" class="row">
        <div class="col table table__wrapper table--responsive table--highlight">
          <table data-init="auto">
            <thead>
            <tr>
              <th class="text-align-left">Destination</th>
              <th data-type="string" class="text-align-left">Price per SMS</th>
              <th data-type="string" class="text-align-right">Recipients</th>
              <th data-type="string" class="text-align-right">
                SMS
                <sdx-menu-flyout>
                  <sdx-menu-flyout-toggle>
                    <sdx-icon icon-name="icon-information-circle" sr-hint="Read more"></sdx-icon>
                  </sdx-menu-flyout-toggle>
                  <sdx-menu-flyout-content>
                    <p>SMS length depends on the placeholders,<br/>
                      therefore the number of SMS cannot be predicted exactly,</p>
                  </sdx-menu-flyout-content>
                </sdx-menu-flyout>
              </th>
            </tr>
            </thead>
            <tbody>
            <tr v-if="this.price.countSwitzerland>0">
              <td class="text-align-left">
                Switzerland
                <sdx-menu-flyout>
                  <sdx-menu-flyout-toggle>
                    <sdx-icon icon-name="icon-information-circle" sr-hint="Read more"></sdx-icon>
                  </sdx-menu-flyout-toggle>
                  <sdx-menu-flyout-content>
                    <p>Provider cannot identified in advance,<br/>
                      so SMS to Swisscom and to other providers are grouped here as Switzerland.</p>
                  </sdx-menu-flyout-content>
                </sdx-menu-flyout>
              </td>
              <td class="text-align-left">
                {{ formatPrice(this.price.smsPrice.priceSwisscom) }} to Swisscom<br/>
                {{ formatPrice(this.price.smsPrice.priceNational) }} to other providers
              </td>
              <td class="text-align-right">
                {{ formatBigNumber(this.price.recipientsSwitzerland) }}
              </td>
              <td class="text-align-right">
                ~{{ formatBigNumber(this.price.countSwitzerland) }}
              </td>
            </tr>
            <tr v-if="this.price.countInternational>0">
              <td class="text-align-left">International</td>
              <td class="text-align-left">
                {{ formatPrice(this.price.smsPrice.priceInternational) }}
              </td>
              <td class="text-align-right">
                {{ formatBigNumber(this.price.recipientsInternational) }}
              </td>
              <td class="text-align-right">
                ~{{ formatBigNumber(this.price.countInternational) }}
              </td>
            </tr>
            <tr>
              <td class="total text-align-left">&nbsp;</td>
              <td class="total text-align-right">Total SMS</td>
              <td class="total text-align-right">
                {{ formatBigNumber(this.price.recipientsTotal) }}
              </td>
              <td class="total text-align-right">
                ~{{ formatBigNumber(this.price.countTotal) }}
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <sdx-loading-spinner ref="spinnerLimitations" sr-hint="Loading. Please wait." class="spinner-dashboard margin-top-1"
                         style="display: none"  srHint = "Loading limitations..." />
    <div id="limitations" ref="limitations" class="row margin-top-1">
      <div class="col table table__wrapper table--responsive table--highlight">
        <table data-init="auto">
          <thead>
          <tr>
            <th class="text-align-left limitations-header" colspan="2">Limitations</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td>
              AllowList:
            </td>
            <td v-if="this.limitationsInvalidPhoneNumbers?.length>0">
              <ul v-for="error in this.limitationsInvalidPhoneNumbers" :key="error">
                <li><b>{{ error.country }}</b></li>
                <template v-for="entry in error.invalidPhoneNumbers" :key="entry">
                  <li>&nbsp;&nbsp;{{ formatBigNumber(entry.row) }}: {{ entry.error }}</li>
                </template>
              </ul>
            </td>
            <td v-else>
              AllowList is not limiting this Campaign.
            </td>
          </tr>
          <tr>
            <td>
              CostLimit:
              <sdx-menu-flyout>
                <sdx-menu-flyout-toggle>
                  <sdx-icon icon-name="icon-information-circle" sr-hint="Read more"></sdx-icon>
                </sdx-menu-flyout-toggle>
                <sdx-menu-flyout-content>
                  <p>SMS length depends on the placeholders,<br/>
                    therefore the CostLimit cannot be predicted exactly,</p>
                </sdx-menu-flyout-content>
              </sdx-menu-flyout>
            </td>
            <td v-if="this.limitationsCostLimit?.length>0">
              <ul v-for="error in this.limitationsCostLimit" :key="error">
                <li>{{ error.error }}</li>
              </ul>
            </td>
            <td v-else>
              CostLimit is not limiting this Campaign.
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="row margin-top-3">
      <div class="col-xs-5">
        <h4 class="text-align-left">
          Preview (first {{ this.previewCount }} recipients)
        </h4>
      </div>
      <div class="col-xs text-align-right" v-if="status == 'CREATED'">

        <sdx-dialog
            v-bind:id="'sms-outbox-export-modal'"
            label="Test SMS"
            class="clearfix"
            type="closable-modal"
            ref="previewSmsDialog"
            v-if="envService.featureToggleCampaignsPreviewSms()"
        >
          <sdx-dialog-toggle>
            <div>
              <sdx-button
                  id="notification-modal-opener"
                  label="Test SMS"
              />
            </div>
          </sdx-dialog-toggle>
          <sdx-dialog-content class="text-align-center">
            <div class="row-2 margin-1">
              <div class="col margin-top-0 margin-bottom-3">
                <div><p class="text-smalls">SMS Text</p></div>
                <div id="previewSmsText" class="sms-container">
                  <p v-html="previewSmsText" class="sms-preview"></p>
                </div>
              </div>
              <div class="col margin-bottom-3">
                <sdx-input
                    id="inputPhoneNumber"
                    label="Phone Number"
                    class="sdx-input"
                    placeholder="+4179..."
                    :value="previewSmsPhoneNumber"
                    @input="(event) => setPreviewSmsPhoneNumber(event)"
                    :validation-message="showInvalidPhoneNumberError(this.previewSmsPhoneNumber) ? 'The number you entered is not a valid phone number' : ''"/>
              </div>
              <div class="col">
                <sdx-button
                    ref="buttonSendSms"
                    label="Send"
                    @click="sendSms"
                    :disabled="!this.previewSmsFormValid"
                    loading="false"
                >
                </sdx-button>
              </div>
            </div>

          </sdx-dialog-content>
        </sdx-dialog>
        <sdx-dialog
            class="text-align-2"
            notification-type="confirmation validation"
            icon-name="icon-check-mark-2-circle"
            label="Done!"
            type="closable-modal"
            ref="successPreviewSmsDialog">
          <sdx-dialog-content>
            <p class="text-align-center">Your Test SMS has been sent successfully!</p>
          </sdx-dialog-content>
        </sdx-dialog>
        <sdx-dialog
            class="margin-1"
            notification-type="warning"
            icon-name="icon"
            label="Error!"
            type="closable-modal"
            ref="errorDialog">
          <sdx-dialog-content>
            <p class="text-align-center">Error while sending Test SMS. Error: {{ this.testSmsError }}</p>
          </sdx-dialog-content>
        </sdx-dialog>
      </div>
    </div>

    <sdx-loading-spinner ref="spinnerPreview" size="large" sr-hint="Loading. Please wait." class="spinner-dashboard"
                         style="display: none"/>
    <div id="preview" ref="preview" class="row">
      <div class="col table table__wrapper table--responsive table--highlight">
        <table>
          <thead>
          <tr>
            <th data-type="string" class="text-align-left">Phone Number</th>
            <th data-type="string" class="text-align-left">Text</th>
            <th data-type="string" class="text-align-left">SMS</th>
            <th data-type="string" class="text-align-left">Encoding</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="message in preview" :key="message.phoneNumber">
            <td class="text-align-left">{{ message.phoneNumber }}</td>
            <td class="text-align-left text-recommended-max-width previewSms" v-html="message.text4Html"></td>
            <td class="text-align-left" style="padding-left: 50px">{{ message.parts }}</td>
            <td class="text-align-left">{{ message.encoding }}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="row flex-items-xs-between margin-top-2">
      <div class="col-xs-4">
        <sdx-button
            label="Overview"
            theme="secondary"
            @click="goToRoute('/campaigns')"
        />
      </div>
      <sdx-loading-spinner id="spinner-campaign" size="large" sr-hint="Loading. Please wait." style="display: none"/>
      <div class="col-xs text-align-right">
        <a id="SendCampaign"/>
        <sdx-button v-if="status == 'CREATED'"
                    label="Send"
                    theme="confirm"
                    icon-name="icon-coins"
                    @click="campaignSend()"
                    class="margin-left-2"/>
        <sdx-dialog
            notification-type="confirmation validation"
            ref="successSendCampaignDialog"
            icon-name="icon-check-mark-2-circle"
            label="Thank you!">
          <sdx-dialog-content>
            <p class="text-align-center">Campaign successfully started and SMS will be sent shortly.</p>
            <sdx-button-group layout="responsive-fill">
              <sdx-button label="Close" @click="goToRoute('/campaigns')"/>
            </sdx-button-group>
          </sdx-dialog-content>
        </sdx-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import campaignsService from '@/modules/campaigns/service.js';
import loadingSpinnerService from '@/services/loading-spinner.service';
import {logger} from "@/services/logger.service";
import {
  showAlert
} from "@/services/notification.service";
import {postSendSms} from '@/modules/sendsms/service';
import {response} from 'msw';
// eslint-disable-next-line no-unused-vars
import {formatBigNumber, formatPrice, isTextNotEmpty, validatePhoneNumber} from "@/util/utility";
import envService from "@/services/env.service";

export default {
  data() {
    return {
      previewCount: 5,
      campaignName: '',
      status: '',
      preview: undefined,
      dataLoaded: false,
      price: [],
      disableSendButton: false,
      previewSmsText: '',
      previewSmsPhoneNumberChanged: false,
      previewSmsPhoneNumber: '',
      previewSmsFormValid: false,
      tag: '',
      testSmsError: '',
      limitationsInvalidPhoneNumbers: 'loading...',
      limitationsCostLimit: 'loading...',
    };
  },
  mounted() {
    this.campaignName = campaignsService.getCampaignName();
    this.status = campaignsService.getCampaignStatus();
    //TODO tag must come from campaign object
    //this.tag = campaignsService.getTagFromSession();
    logger.debug("loadPrices..")
    this.loadPrices();
    logger.debug("loadPreview..")
    this.loadPreview();
    logger.debug("loadLimitations..")
    this.loadLimitations();
  },
  computed: {
    envService() {
      return envService
    }
  },
  methods: {
    formatPrice,
    formatBigNumber,
    async loadPreview() {
      await this.$nextTick()
      loadingSpinnerService.showByRef(this.$refs.spinnerPreview, this.$refs.preview);
      try {
        const response = await campaignsService.getPreview(campaignsService.getCampaignWebId(), campaignsService.getCampaignId(), this.previewCount);
        this.preview = response.data;
        this.previewSmsText = this.preview[0].text4Html;
        this.previewSmsPhoneNumber = sessionStorage.getItem(`phoneNumber`);
      } catch (error) {
        showAlert(error.message)
      }
      loadingSpinnerService.hideByRef(this.$refs.spinnerPreview, this.$refs.preview);
    },
    goToRoute(route) {
      this.$router.push(route);
    },
    async loadPrices() {
      await this.$nextTick()
      loadingSpinnerService.showByRef(this.$refs.spinnerPrice, this.$refs.price);
      try {
        const response = await campaignsService.getPrice(campaignsService.getCampaignWebId(), campaignsService.getCampaignId());
        this.price = response.data;
        this.dataLoaded = true;
      } catch (error) {
        showAlert(error.message)
      }
      loadingSpinnerService.hideByRef(this.$refs.spinnerPrice, this.$refs.price);
    },
    async loadLimitations() {
      await this.$nextTick()
      loadingSpinnerService.showByRef(this.$refs.spinnerLimitations, this.$refs.limitations);
      try {
        const response = await campaignsService.getLimitations(campaignsService.getCampaignWebId(), campaignsService.getCampaignId());
        logger.error("not catched..............")
        this.limitationsInvalidPhoneNumbers = response.data.invalidPhoneNumbers;
        logger.debug("Phone Numbers Limitations: " + this.limitationsInvalidPhoneNumbers?.length)
        this.limitationsCostLimit = response.data.costLimitErrors;
        logger.debug("Cost Limit Limitations: " + this.limitationsCostLimit?.length)
        logger.debug("Limitations: " + this.limitationsCostLimit)
      } catch (error) {
        logger.error("catched..............")
        showAlert(error.message)
      }
      loadingSpinnerService.hideByRef(this.$refs.spinnerLimitations, this.$refs.limitations);
    },
    async campaignSend() {
      try {
        this.disableSendButton = true;
        await campaignsService.putCampaignStatus(campaignsService.getCampaignWebId(), campaignsService.getCampaignId());
        this.$refs.successSendCampaignDialog.open()
      } catch {
        showAlert('Could not start Campaign!');
      }
    },
    async sendSms() {
      this.$refs.buttonSendSms.loading = true;
      this.disableSendButton = true;
      this.testSmsError = '';
      var result = await postSendSms(campaignsService.getCampaignWebId(), this.previewSmsPhoneNumber, this.preview[0].text, ["Campaigns", "PreviewSMS"]);
      if (result.status === 200 && result.data.success == true) {
        this.$refs.previewSmsDialog.close();
        this.$refs.successPreviewSmsDialog.open();
      } else {
        this.$refs.previewSmsDialog.close();
        this.testSmsError = result.data.error
        this.$refs.errorDialog.open();
      }
      this.disableSendButton = false;
      this.$refs.buttonSendSms.loading = false;
    },
    async thisText() {
      this.text = response.data;
    },
    setPreviewSmsPhoneNumber(event) {
      this.previewSmsPhoneNumber = event.srcElement.value;
      this.validatePreviewSmsForm()
    },
    showInvalidPhoneNumberError(phoneNumber) {
      return !(phoneNumber == null || phoneNumber == "" || validatePhoneNumber(phoneNumber))
    },
    validatePreviewSmsForm() {
      this.previewSmsFormValid = validatePhoneNumber(this.previewSmsPhoneNumber);
    }
  },
};
</script>

<style scoped>
.container {
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.total {
  font-weight: bold;
}

.previewSms {
  word-wrap: break-word;
}

.limitations-header{
  padding-top: 10px;
  padding-bottom: 10px;
  background-color: #ffeeee;
}

</style>
